"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/MembersTab/components/UserTile/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Link = require('web/components/Settings/Link'); var _Link2 = _interopRequireDefault(_Link);





var _useOrgAccount = require('shared/hooks/useOrgAccount');

var _Avatar = require('web/components/Avatar');
var _Tooltip = require('web/components/Tooltip');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);


























const stopPropagation = e => e.stopPropagation()

// F-9: why an org Admin can't follow the lock to the Account page.
 const ACCOUNT_ROLE_VIEW_ONLY_HINT = "Only Owners and IT can view or change this person's account role."; exports.ACCOUNT_ROLE_VIEW_ONLY_HINT = ACCOUNT_ROLE_VIEW_ONLY_HINT

const UserTile = ({
  entity, isMe, orgKey,
  onApprove, onReject, onRemove,
  onEdit, onResendInvite, onGotoUser, lock, onOpenAccountPerson,
}) => {
  const lockLabel = _useOrgAccount.memberLockLabel.call(void 0, lock)
  const accountRole = _optionalChain([lock, 'optionalAccess', _ => _.AccountRole])
  const pendingRel = _optionalChain([entity, 'access', _2 => _2.wrappedEntity, 'access', _3 => _3.PendingRelationships, 'optionalAccess', _4 => _4[orgKey]])
  const activeRel = entity.wrappedEntity.Relationships[orgKey]
  const isActivated = entity.wrappedEntity.Activated
  const isPending = !!pendingRel
  const isAdmin = _optionalChain([activeRel, 'optionalAccess', _5 => _5.RelType]) === 'admin'
  const title = _optionalChain([activeRel, 'optionalAccess', _6 => _6.Title]) || _optionalChain([pendingRel, 'optionalAccess', _7 => _7.Title])
  const userKey = entity.wrappedEntity.UserKey

  const actions = _react.useMemo.call(void 0, 
    () => [
      ...(!isActivated && onResendInvite
        ? [{ label: 'Resend invite', onClick: () => onResendInvite(userKey) }]
        : []
      ),
      ...(isActivated && !isPending && onEdit && !lockLabel
        ? [{ label: 'Manage', onClick: () => onEdit(entity) }]
        : []
      ),
      ...(isPending && onApprove && onReject
        ? [
            { label: 'Approve', onClick: () => onApprove(entity) },
            { isDestructive: true, label: 'Reject', onClick: () => onReject(entity) },
          ]
        : []
      ),
      ...(!isPending && onRemove && !lockLabel
        ? [{ isDestructive: true, label: 'Remove', onClick: () => onRemove(entity) }]
        : []
      ),
    ],
    [
      userKey, entity, onResendInvite, onEdit, onApprove,
      onReject, isActivated, isPending, onRemove, lockLabel,
    ],
  )

  return (
    _react2.default.createElement('div', {
      role: onGotoUser ? "button" : "none",
      className: _classBuilder2.default.call(void 0, 
        "settings--org-members--member",
        onGotoUser && "settings--org-members--member--interactive",
      ),
      onClick: () => _optionalChain([onGotoUser, 'optionalCall', _8 => _8(userKey)]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}

      , _react2.default.createElement('div', { className: "settings--org-members--member-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
        , _react2.default.createElement(_Avatar.EntityAvatar, { entity: entity, __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}} )
      )
      , _react2.default.createElement('div', { className: "settings--org-members--member-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
        , _react2.default.createElement('span', { className: "settings--org-members--member-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
          , _react2.default.createElement('span', { className: "settings--org-members--member-name-text", title: entity.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}},  entity.name )
          ,  isMe && (
            _react2.default.createElement('span', { className: "settings--org-members--member-is-me", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, "(You)")
          )
          ,  accountRole && (
            _react2.default.createElement('span', { className: `settings--org-members--member-badge settings--org-members--member-badge--${accountRole}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
              ,  _useOrgAccount.ACCOUNT_ROLE_LABELS[accountRole] 
            )
          )
          ,  isAdmin && !accountRole && (
            _react2.default.createElement('span', { className: "settings--org-members--member-badge settings--org-members--member-badge--admin" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}, "Admin")
          )
          ,  isPending && (
            _react2.default.createElement('span', { className: "settings--org-members--member-badge settings--org-members--member-badge--pending" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}, "Pending"

            )
          )
        )
        , _react2.default.createElement('span', { className: "settings--org-members--member-email", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
          ,  entity.wrappedEntity.Email 
        )
        , _react2.default.createElement('span', { className: "settings--org-members--member-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}},  title )
      )
      , _react2.default.createElement('div', {
        className: "settings--org-members--member-controls",
        onClick: stopPropagation, __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}

        ,  lockLabel && _useOrgAccount.isSetOnAccountPage.call(void 0, lock) && onOpenAccountPerson && (
          _react2.default.createElement(_Link2.default, { role: "button", className: "settings--org-members--member-lock-link", onClick: () => onOpenAccountPerson(userKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
            , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}, "🔒 " ),  lockLabel 
          )
        )
        ,  lockLabel && _useOrgAccount.isSetOnAccountPage.call(void 0, lock) && !onOpenAccountPerson && (
          _react2.default.createElement(_Tooltip.HoverTooltip, {
            type: "dark",
            place: "top",
            showOnFocus: true,
            className: "settings--org-members--member-lock-tip",
            content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 139}},  exports.ACCOUNT_ROLE_VIEW_ONLY_HINT ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}

            , _react2.default.createElement('span', { className: "settings--org-members--member-lock", tabIndex: 0, 'aria-label': `${lockLabel}. ${exports.ACCOUNT_ROLE_VIEW_ONLY_HINT}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
              , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}, "🔒 " ),  lockLabel 
            )
          )
        )
        ,  lockLabel && !_useOrgAccount.isSetOnAccountPage.call(void 0, lock) && (
          _react2.default.createElement('span', { className: "settings--org-members--member-lock", __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}}
            , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}, "🔒 " ),  lockLabel 
          )
        )
        ,  actions.map((a, i) => (
          _react2.default.createElement(_Link2.default, {
            key: i,
            role: "button",
            onClick: a.onClick,
            className: a.isDestructive
              ? 'settings--org-members--member-remove'
              : ''
            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}

            ,  a.label 
          )
        )) 
      )
    )
  )
}

exports. default = UserTile
